import { toObservationData } from '../../factory'; 
export const FETCH_OBSERVATIONS = 'FETCH_OBSERVATIONS';
export const STORE_OVERLAYS = 'STORE_OVERLAYS';
export const SELECT_CAMPAIGN = 'SELECT_CAMPAIGN';

export const fetchObservations = data => ({ type: FETCH_OBSERVATIONS, payload: toObservationData(data) });
export const storeOverlays = overlays => ({ type: STORE_OVERLAYS, payload: overlays});
export const selectCampaign = campaign => ({ type: SELECT_CAMPAIGN, payload: campaign});